import React from "react";
import { Input, Button, Icon, Grid } from "semantic-ui-react";
import PropTypes from "prop-types";

const SearchFilters = ({
  searchQuery,
  onSearchInputChange,
  onClearFilters,
  placeholder = "Search by patron name or email...",
  showClearButton = true,
}) => {
  return (
    <Grid stackable style={{ marginBottom: "1rem" }}>
      <Grid.Row>
        <Grid.Column width={showClearButton ? 12 : 16}>
          <Input
            fluid
            icon="search"
            iconPosition="left"
            placeholder={placeholder}
            value={searchQuery}
            onChange={onSearchInputChange}
            style={{ fontSize: "1em" }}
          />
        </Grid.Column>

        {showClearButton && (
          <Grid.Column width={4}>
            <Button
              fluid
              icon
              labelPosition="left"
              onClick={onClearFilters}
              disabled={!searchQuery}
            >
              <Icon name="x" />
              Clear
            </Button>
          </Grid.Column>
        )}
      </Grid.Row>
    </Grid>
  );
};

SearchFilters.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  onSearchInputChange: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  showClearButton: PropTypes.bool,
};

export default SearchFilters;
